import { Link, useLocation } from "react-router-dom";
import { Logo, SOCIALS } from "../../../constants";
import classes from "./footer.module.css";
import { useEffect, useRef } from "react";

const LandingFooter = () => {
  const LINKS = [
    {
      to: "/#about-us",
      text: "About us",
    },
    // {
    //   to: "/#premium-access",
    //   text: "Pricing",
    // },
    // {
    //   to: "/",
    //   text: "Jobs",
    // },
    {
      to: "/#how-it-works",
      text: "How it works",
    },
    {
      to: "/team",
      text: "Team",
    },
    {
      to: "/contact-us",
      text: "Contact us",
    },
  ];

  const location = useLocation();
  const lastHash = useRef('');

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
    }

    if (lastHash.current && document.getElementById(lastHash.current)) {
      setTimeout(() => {
        const offset = 100;
        const sectionPosition =
        document.getElementById(lastHash.current)?.getBoundingClientRect().top +
          window.scrollY;
        window.scrollTo({
          top: sectionPosition - offset,
          behavior: "smooth",
        });
        lastHash.current = '';
      }, 100);
    }
  }, [location]);
  
  return (
    <div className={classes.footer}>
      <div className={`flex ${classes.container}`}>
        <div>
          <div>
            <Logo color="#fff" />
          </div>
          <p className={classes.desc}>
            Connecting talents with businesses, businesses with talents.
          </p>
        </div>
        <div className={classes["link-grid"]}>
          {LINKS.map((link, i) => (
            <Link
              to={link.to}
              onClick={() => {
                const offset = 100;
                const sectionPosition =
                link?.ref?.current.getBoundingClientRect().top +
                  window.scrollY;
                window.scrollTo({
                  top: sectionPosition - offset,
                  behavior: "smooth",
                });
              }}
              key={`footer-link-${i}`}
            >
              {link.text}
            </Link>
          ))}
        </div>
        <div className={classes["social-grid"]}>
          {SOCIALS.map((social, i) => (
            <a
              href={social.href}
              target="_blank"
              rel="noreferrer"
              key={`external-link-${i}`}
            >
              <social.image />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingFooter;
